export default new (class {
  constructor() {
    this.selectors = {
      checkbox: '.filter-checkbox',
      arrow: '.filter-item__arrow',
      group: '.filter-group',
      filterToggle: '.filter-toggle',
      filterColumn: '.archive-sidebar-column',
    };

    this.classes = {
      active: 'active',
      hidden: 'hidden',
      body_fixed_class: 'menu-open',
      arrow_closed: 'filter-item--closed',
    };

    this.taxonomies = new Set();
    this.selectedFilters = [];
  }

  init() {
    this.getDOM();
    this.bindEvents();
    this.setTaxonomies();
    this.setParams();
  }

  getDOM() {
    this.DOM = {
      body: document.body,
      filterColumn: document.querySelector(this.selectors.filterColumn),
      filterToggle: document.querySelectorAll(this.selectors.filterToggle),
      groups: document.querySelectorAll(this.selectors.group),
      checkboxes: document.querySelectorAll(this.selectors.checkbox),
      arrows: document.querySelectorAll(this.selectors.arrow),
    };
  }

  bindEvents() {
    Array.from(this.DOM.checkboxes).forEach((checkbox) => {
      checkbox.addEventListener(
        'change',
        this.handleCheckbox.bind(this, checkbox),
      );
    });
    Array.from(this.DOM.arrows).forEach((arrow) => {
      arrow.addEventListener('click', this.handleArrowClick.bind(this, arrow));
    });

    Array.from(this.DOM.filterToggle).forEach((toggle) => {
      toggle.addEventListener(
        'click',
        this.toggleShowFilters.bind(this, toggle),
      );
    });
  }

  toggleBodyFixed() {
    if (this.DOM.body.classList.contains(this.classes.body_fixed_class)) {
      this.DOM.body.classList.remove(this.classes.body_fixed_class);
    } else {
      this.DOM.body.classList.add(this.classes.body_fixed_class);
    }
  }

  toggleShowFilters() {
    this.DOM.body.classList.toggle('filters-open');
  }

  setParams() {
    const queryString = window.location.search;
    this.params = new URLSearchParams(queryString);

    this.taxonomies.forEach((taxonomy) => {
      this.params
        .getAll(taxonomy)
        .toString()
        .split(',')
        .forEach((value) => {
          this.addFilter(taxonomy, value);
        });
    });
  }

  setTaxonomies() {
    Array.from(this.DOM.checkboxes).forEach((checkbox) => {
      this.taxonomies.add(checkbox.dataset.taxonomy);
    });
  }

  handleArrowClick(arrow) {
    const parent = arrow.parentElement;
    parent.classList.toggle(this.classes.arrow_closed);
  }

  addFilter(taxonomy, value) {
    if (!this.selectedFilters[taxonomy]) {
      this.selectedFilters[taxonomy] = new Set();
    }
    this.selectedFilters[taxonomy].add(value);
  }

  handleCheckbox(checkbox) {
    const { taxonomy, parent, type } = checkbox.dataset;
    const hasParent = !!parent;
    const isSingle = type === 'single';
    const isMultiple = type === 'multiple';

    if (checkbox.checked && isSingle) {
      if (hasParent) {
        this.addFilter(taxonomy, parent);
      } else {
        this.selectedFilters[taxonomy].clear();
      }
      this.addFilter(taxonomy, checkbox.value);
    }

    if (checkbox.checked && isMultiple) {
      if (hasParent) {
        if (!this.selectedFilters[taxonomy].has(parent)) {
          this.selectedFilters[taxonomy].clear();
        }
        this.addFilter(taxonomy, parent);
      }
      this.addFilter(taxonomy, checkbox.value);
    }

    if (!checkbox.checked && isSingle) {
      if (hasParent) {
        this.selectedFilters[taxonomy].delete(checkbox.value);
      } else {
        this.selectedFilters[taxonomy].clear();
      }
    }

    if (!checkbox.checked && isMultiple) {
      this.selectedFilters[taxonomy].delete(checkbox.value);
    }
    this.applyFilters();
  }

  applyFilters() {
    Object.entries(this.selectedFilters).forEach((filter) => {
      this.params.set(filter[0], [...filter[1]].toString());
    });
    window.location.search = this.params.toString();
  }
})();
